import classNames from 'classnames';
import { isAllowed, isRequired, SeamlessHomeWrapperProps } from '.';

import styles from './SeamlessHomeLink.module.scss';

export const SeamlessHomeWrapper = ({ style, className, children }: SeamlessHomeWrapperProps) => {
  if (isAllowed && isRequired) {
    return (
      <div style={style} className={classNames(styles.wrapper, className ?? '')}>
        {children}
      </div>
    );
  }

  return null;
};
